import { Divider, Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import errorPage from '../../assets/images/errorPage.jpg';
import { useLoaderContext } from '../../contexts/LoaderContext';
import { StyledTitle } from '../../components/StyledTitle';
import { StyledDescription } from '../../components/StyledDescription';

export const RefusedPromoPage: React.FC = () => {

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
    }, []);

    return (
        <Grid height="100%" container>{matches && (
            <Grid sm={5} sx={{ backgroundColor: '#E5EAF0', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                <img src={errorPage} width="300" alt='genericPage' />
            </Grid>
        )}
            <Grid
                sm={matches ? 7 : 12}
                sx={{
                    background: "#fff"
                }}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        ATTENZIONE!
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <StyledDescription>
                        La tua Azienda ha rifiutato la promozione esclusiva per l'offerta relativa al modulo software "Concordato Preventivo Biennale"!
                        <br />
                        <br />
                        Se in futuro fossi interessato, potrai sempre contattare il tuo riferimento TeamSystem.
                        <br />
                        <br />
                        Buon Lavoro!
                    </StyledDescription>
                </Box>
            </Grid>
        </Grid>
    );
};
